module.exports = __webpack_public_path__ + "img/grayBackImg.cf14716d.png";